import { arcList } from "@/mocks/manga";

export default function PlotTimeline() {
  return (
    <section id="plot" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-sm font-medium tracking-wide text-primary-600">STORYLINE</span>
            <h2 className="font-heading mt-2 text-3xl text-foreground-950 md:text-4xl">剧情主线追踪</h2>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-foreground-600">
              按篇章梳理《甜蜜惩罚》的主线走向，标注每个阶段的关键节点与剧情爆发点，
              让你一眼看清整条故事脉络，追更不再迷路。
            </p>
          </div>
          <span className="rounded-full bg-secondary-100 px-4 py-1.5 text-sm text-secondary-900">
            截至第 61+ 话
          </span>
        </div>

        <div className="relative mt-12">
          <div className="absolute left-4 top-0 h-full w-px bg-background-300 md:left-1/2 md:-translate-x-1/2" />
          <div className="flex flex-col gap-8">
            {arcList.map((arc, i) => (
              <div
                key={arc.title}
                className={`relative flex flex-col gap-4 pl-12 md:w-1/2 md:pl-0 ${
                  i % 2 === 0
                    ? "md:pr-14 md:text-right"
                    : "md:ml-auto md:pl-14"
                }`}
              >
                <span
                  className={`absolute left-0 top-1 flex h-8 w-8 items-center justify-center rounded-full text-sm text-background-50 md:left-auto ${
                    i % 2 === 0
                      ? "md:-right-4"
                      : "md:-left-4"
                  }`}
                  style={{ backgroundColor: "oklch(var(--primary-500))" }}
                >
                  {i + 1}
                </span>
                <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                  <div
                    className={`flex flex-wrap items-center gap-2 ${
                      i % 2 === 0 ? "md:justify-end" : ""
                    }`}
                  >
                    <span className="rounded-full bg-accent-100 px-3 py-0.5 text-xs font-medium text-accent-900">
                      {arc.tag}
                    </span>
                    <span className="text-sm text-foreground-500">{arc.period}</span>
                  </div>
                  <h3 className="font-heading mt-3 text-xl text-foreground-950">{arc.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{arc.desc}</p>
                  <ul className={`mt-4 flex flex-col gap-2 text-sm text-foreground-700 ${i % 2 === 0 ? "md:items-end" : ""}`}>
                    {arc.points.map((p) => (
                      <li key={p} className="flex items-center gap-2">
                        <i className="ri-heart-3-line text-primary-500" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}